import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faBoxOpen,
  faBuildings,
  faMapLocation,
  faRoute,
  faTimelineArrow,
  faTruck,
  faTruckFast,
  faUsersGear,
  faUserTag,
} from '@fortawesome/pro-light-svg-icons';

export interface BuiltInApiInformation {
  icon: IconProp;
  description: string;
  linkUrl: string;
  linkText: string;
}

export const GetBuiltInApiInformation = async (): Promise<
  BuiltInApiInformation[]
> => {
  return [
    {
      icon: faTruck,
      description:
        'Build your own vehicle and transport management application using the Vehicle API',
      linkText: 'Vehicle API',
      linkUrl: 'https://docs.getos1.com/vehicle-api',
    },
    {
      icon: faUsersGear,
      description:
        'Build your own user management application using the User API',
      linkText: 'User API',
      linkUrl: 'https://docs.getos1.com/user-api',
    },
    {
      icon: faTimelineArrow,
      description:
        'Register and manage logistics workflows using the Workflow API',
      linkText: 'Workflow API',
      linkUrl: 'https://docs.getos1.com/workflow',
    },
    {
      icon: faUserTag,
      description:
        'Onboard and manage the lifecycle of participants using the Participant API',
      linkText: 'Participant API',
      linkUrl: 'https://docs.getos1.com/participant',
    },
    {
      icon: faRoute,
      description:
        'Store and monitor real-time location of your device using the Motion Tracking API',
      linkText: 'Motion Tracking API',
      linkUrl: 'https://docs.getos1.com/motion-tracking-system',
    },
    {
      icon: faMapLocation,
      description:
        'Create and manage locations and addresses using the Location API',
      linkText: 'Location API',
      linkUrl: 'https://docs.getos1.com/location',
    },
    {
      icon: faBuildings,
      description:
        'Build your own facility management application using the Facility API',
      linkText: 'Facility API',
      linkUrl: 'https://docs.getos1.com/facility-api',
    },
    {
      icon: faBoxOpen,
      description:
        'Create and manage containers such as Package and Box using the Container API',
      linkText: 'Container API',
      linkUrl: 'https://docs.getos1.com/container',
    },
    {
      icon: faTruckFast,
      description:
        'Create and monitor the lifecycle of a dispatch using the Dispatch API',
      linkText: 'Dispatch API',
      linkUrl: 'https://docs.getos1.com/dispatch',
    },
  ];
};
